<template>
  <footer class="footer">
    <div class="footer-box">
      <nav class="footer-nav">
        <ul class="footer-nav-list">
          <li class="footer-nav-item">
            <router-link to="/contact" class="footer-router-link">Contact</router-link> 
          </li>
          <li class="footer-nav-item">
            <router-link to="/connexion" class="footer-router-link">Connexion</router-link> 
          </li>
        </ul>
      </nav>
      <div>Site de l'école de Brens : Tous droits réservés</div>
    </div>
  </footer>
</template>

<style scoped>
  .footer {
    margin-bottom: 100px;

    background-color: white;

    padding: 15px 0 15px 0;

    margin-left: auto;
    margin-right: auto;

    max-width: var(--page-size);

    border-radius: var(--page-border-radius);
  }

  .footer-box {
    padding-left: 10px;
    padding-right: 10px;
    margin-top: auto;
    margin-bottom : auto;
    text-align: center;
  }

  .footer-nav-list {
    padding: 5px 5px 5px 5px;
    list-style-type: none;
    text-align: center;
    display: flex;
    justify-content: center;

    margin-block-start: 0px;
    margin-block-end: 0px;
  }

  .footer-nav-item {
    margin-left: 7px;
    margin-right: 7px;
  }
</style>


<script lang="ts">
  import { Component, Vue } from 'vue-property-decorator';

  /**
   * @desc composant de pied de page
   */
  @Component({
    components: {},
  })
  export default class PageFooter extends Vue {
    name = 'page-footer';
  }
</script>
